<cac-dialog-layout
  [title]="data.user ? 'Edit Admin' : 'Create new Admin'"
  subtitle="Enter the required data and save"
  [form]="form"
  (onSubmit)="onSubmit($event)"
>
  <div class="flex gap-6 mt-3">
    <div class="grid grid-cols-2 gap-x-6 gap-y-2 w-full">
      <cac-field [control]="form.controls.fullName" label="Full Name"></cac-field>

      <cac-field [control]="form.controls.username" label="Username"></cac-field>
      <cac-field [control]="form.controls.email" label="Email"></cac-field>
    </div>
  </div>
  <div class="grid grid-cols-2 gap-x-6 gap-y-2 mt-5">
    <cac-field
      [control]="form.controls.status"
      label="Status"
      controlType="select"
      [searchable]="false"
      [clearable]="false"
      [items]="StatusValues"
    ></cac-field>
    <cac-switch [control]="form.controls.isRestrictedAdmin" label="Restricted Admin"></cac-switch>
    <cac-field
      [control]="form.controls.password"
      label="Password"
      inputType="password-eye"
      autoComplete="new-password"
    ></cac-field>
    <cac-field
      [control]="form.controls.passwordConfirm"
      label="Confirm Password"
      inputType="password-eye"
      autoComplete="new-password"
    ></cac-field>
  </div>
  <div class="flex gap-2 me-auto" slot="bottom">
    <cac-button (onClick)="onForceLogout($event)" appearance="stroked" *ngIf="data.user">Force Login</cac-button>
    <cac-button (onClick)="onDelete($event)" theme="error" *ngIf="data.user && !isRestrictedAdmin">Delete user</cac-button>
  </div>
</cac-dialog-layout>
